/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LinkedCompany } from './LinkedCompany';
import {
    LinkedCompanyFromJSON,
    LinkedCompanyFromJSONTyped,
    LinkedCompanyToJSON,
    LinkedCompanyToJSONTyped,
} from './LinkedCompany';

/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    phoneExtension: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    branchName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    branchId?: string;
    /**
     * 
     * @type {LinkedCompany}
     * @memberof UserInfo
     */
    company: LinkedCompany;
    /**
     * 
     * @type {Array<LinkedCompany>}
     * @memberof UserInfo
     */
    linkedCompanies: Array<LinkedCompany>;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    isLinkedCompany: boolean;
}

/**
 * Check if a given object implements the UserInfo interface.
 */
export function instanceOfUserInfo(value: object): value is UserInfo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('phoneExtension' in value) || value['phoneExtension'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('linkedCompanies' in value) || value['linkedCompanies'] === undefined) return false;
    if (!('isLinkedCompany' in value) || value['isLinkedCompany'] === undefined) return false;
    return true;
}

export function UserInfoFromJSON(json: any): UserInfo {
    return UserInfoFromJSONTyped(json, false);
}

export function UserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'email': json['email'],
        'name': json['name'],
        'phone': json['phone'],
        'phoneExtension': json['phoneExtension'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'company': LinkedCompanyFromJSON(json['company']),
        'linkedCompanies': ((json['linkedCompanies'] as Array<any>).map(LinkedCompanyFromJSON)),
        'isLinkedCompany': json['isLinkedCompany'],
    };
}

  export function UserInfoToJSON(json: any): UserInfo {
      return UserInfoToJSONTyped(json, false);
  }

  export function UserInfoToJSONTyped(value?: UserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'email': value['email'],
        'name': value['name'],
        'phone': value['phone'],
        'phoneExtension': value['phoneExtension'],
        'branchName': value['branchName'],
        'branchId': value['branchId'],
        'company': LinkedCompanyToJSON(value['company']),
        'linkedCompanies': ((value['linkedCompanies'] as Array<any>).map(LinkedCompanyToJSON)),
        'isLinkedCompany': value['isLinkedCompany'],
    };
}

